import type { IconData } from '@stacksjs/iconify-core'

export const layerGroup: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M12 14.195c-.176 0-.348-.046-.5-.133l-9-5.198a1 1 0 0 1 0-1.732l9-5.194c.31-.177.69-.177 1 0l9 5.194a1 1 0 0 1 0 1.732l-9 5.198a1 1 0 0 1-.5.133\" opacity=\".25\"/><path fill=\"currentColor\" d=\"m21.5 11.132l-1.964-1.134l-7.036 4.064c-.31.178-.69.178-1 0L4.464 9.998L2.5 11.132a1 1 0 0 0 0 1.732l9 5.198c.31.178.69.178 1 0l9-5.198a1 1 0 0 0 0-1.732\" opacity=\".5\"/><path fill=\"currentColor\" d=\"m21.5 15.132l-1.964-1.134l-7.036 4.064c-.31.178-.69.178-1 0l-7.036-4.064L2.5 15.132a1 1 0 0 0 0 1.732l9 5.198c.31.178.69.178 1 0l9-5.198a1 1 0 0 0 0-1.732\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default layerGroup
